"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatToCatalogsDate = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
const formatToCatalogsDate = (dateStr, language) => {
    return (0, libs_utils_1.formatDate)((0, libs_utils_1.parseDateStr)(dateStr), 'MMM yyyy', language);
};
exports.formatToCatalogsDate = formatToCatalogsDate;
//# sourceMappingURL=formatToCatalogsDate.js.map